import React, { useState, useEffect } from "react";
import { Box, Stack, Typography, styled, Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import { useNavigate, Link } from "react-router-dom";
import api from "../constants/API";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { SiteId } from "../constants/constants";

const RootStyle = styled(Box)(({ theme }) => ({
  // minHeight: "95px",
  minWidth: "500px",
  height: "auto",
  background: "#FFFFFF",
  borderRadius: "10px",
  margin: "5px 10px",
  padding: "10px",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "8px",
    minWidth: "90%",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "8px",
    minWidth: "90%", // Adjust width for extra small screens
  },
}));
const ImgBox = styled(Box)(({ theme }) => ({
  minHeight: "70px",
  minWidth: "290.9px",
  background: "#ebebeb",
  borderRadius: "10px",
  padding: "0 5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    // minHeight:"220px",
    width: "95%",
    minWidth: "30%",
  },
  [theme.breakpoints.down("xs")]: {
    // minHeight:"220px",
    borderRadius: "10px",
    padding: "0 5px",
    width: "95%",
    minWidth: "30%", // Adjust width for extra small screens
  },
}));
const CommentsBox = styled(Box)(({ theme }) => ({
  marginTop: "10px",
  width: "100%",
  height: "27px",
  background: "#444647",
  borderRadius: "0px 10px 10px 0px",
  display: "flex",
  justifyContent: "flex-end",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
    minWidth: "25%",
  },
  [theme.breakpoints.down("xs")]: {
    width: "95%",
    minWidth: "25%", // Adjust width for extra small screens
  },
}));
const StarsBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "27px",
  background: "#27B1BB",
  borderRadius: "0px 10px 10px 0px",
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    minWidth: "25%",
  },
  [theme.breakpoints.down("xs")]: {
    minWidth: "25%", // Adjust width for extra small screens
  },
}));

function RatingCard({ item }) {
  const [currentExamRating, setCurrentExamRating] = useState(null);
  const [examDiscussion, setExamDiscussion] = useState(0);

  useEffect(() => {
    // Handle different rating structures
    const parseRating = (rating) => {
      if (typeof rating === "number") {
        return rating; // Already a number
      }
      if (rating && rating.$numberDecimal) {
        return parseFloat(rating.$numberDecimal); // Parse decimal rating
      }
      return 0; // Default to 0 if no valid rating
    };

    setCurrentExamRating(parseRating(item?.Rating));
    setExamDiscussion(item.DiscussionCount || 0);
  }, [item.ExamId]);

  const ExamVendorName = encodeURIComponent(item?.ExamVendorName).replace(
    /%20/g,
    "-"
  );
  const ExamCode_ = encodeURIComponent(item?.ExamCode).replace(/%20/g, "-");

  return (
    <RootStyle>
      <Stack
        width="100%"
        direction={{ md: "row", sx: "column", xs: "column" }}
        spacing={2}
      >
        <ImgBox>
          <Stack>
            <Link
              to={`/${ExamVendorName.toLowerCase().replace(
                /%2b/g,
                "p"
              )}/${ExamCode_.toLowerCase()}`}
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontFamily: "Poppins",
                fontWeight: "500",
                textDecoration: "none",
                color: "black",
                fontSize: "clamp(0.9rem, 2vw, 1.1rem)",
              }}
            >
              {item.ExamCode}
            </Link>
            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                color: "#7c7575",
                fontSize: "clamp(0.7rem, 2vw, 0.9rem)",
              }}
            >
              {item.ExamName}
            </Typography>
          </Stack>
        </ImgBox>
        <Box sx={{ minHeight: "62px", borderRadius: "10px" }}>
          <StarsBox>
            <Stack direction="row" alignItems="center" paddingLeft="10px">
              <Rating
                value={currentExamRating || 0}
                precision={0.1}
                readOnly
                sx={{
                  "& .MuiRating-iconFilled": {
                    color: "#FFD500",
                  },
                  "& .MuiRating-iconEmpty": {
                    color: "#E0E0E0",
                  },
                }}
              />
            </Stack>
            <Stack alignItems="center" justifyContent="center">
              <Typography sx={{ color: "#FFFFFF", mt: 0.2, mr: 1 }}>
                {currentExamRating?.toFixed(1) + "/5" || "N/A"}
              </Typography>
            </Stack>
          </StarsBox>
          <CommentsBox>
            <Stack>
              <ChatBubbleIcon
                sx={{
                  marginTop: "4px",
                  paddingRight: "6px",
                  fontSize: "22px",
                  color: "#F0F0F0",
                }}
              />
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "10px",
                  fontWeight: 700,
                  mt: -2.4,
                  mr: 0.5,
                  textAlign: "center",
                }}
              >
                {examDiscussion}
              </Typography>
            </Stack>
          </CommentsBox>
        </Box>
      </Stack>
    </RootStyle>
  );
}

export default RatingCard;
